import { render, staticRenderFns } from "./ViewFundsReversal.vue?vue&type=template&id=3c212b16&scoped=true&"
import script from "./ViewFundsReversal.vue?vue&type=script&lang=js&"
export * from "./ViewFundsReversal.vue?vue&type=script&lang=js&"
import style0 from "./ViewFundsReversal.vue?vue&type=style&index=0&id=3c212b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c212b16",
  null
  
)

export default component.exports